import { tsParticles } from "@tsparticles/engine";
import { loadAll } from "@tsparticles/all";

async function initParticles() {
  // 1. Завантажуємо всі необхідні плагіни (форми, лінії, анімації)
  await loadAll(tsParticles);

  // 2. Ініціалізуємо наш зоряний фон
  await tsParticles.load({
    id: "particles-js",
    options: {
      particles: {
        number: {
          value: 80,
          density: { enable: true, width: 800, height: 800 }
        },
        color: { value: "#ff9500" }, // Помаранчеві зірки
        shape: { type: "circle" },
        opacity: { value: 0.4 },
        size: {
          value: { min: 1, max: 8 } // Різний розмір для глибини
        },
        links: {
          enable: true,
          distance: 120,
          color: "#ff9500", // Золоті сузір'я
          opacity: 0.5,
          width: 1
        },
        move: {
          enable: true,
          speed: 0.2, // Трішки повільніше для плавності космосу
          direction: "none",
          random: false,
          straight: false,
          outModes: "out"
        }
      },
      interactivity: {
        events: {
          onHover: { enable: true, mode: "grab" },
          onClick: { enable: true, mode: "push" },
          resize: true
        },
        modes: {
          grab: { distance: 200, links: { opacity: 1 } },
          push: { quantity: 3 }
        }
      },
      clear: true
    }
  });
}

// Запуск
initParticles();
